import React, { FunctionComponent, useState } from "react";
import { Aside, ListActionButtonProps } from "sprint-common-web";

import { EditListButton } from "../../../../common/components/buttons/EditListButton";
import { EditManzanitaPresetForm } from "../forms/edit/EditManzanitaPresetForm";
import { ManzanitaPresetListingItem } from "../ManzanitaPresetListingItem";

export type EditManzanitaPresetButtonProps = ListActionButtonProps<ManzanitaPresetListingItem>;

export const EditManzanitaPresetButton: FunctionComponent<EditManzanitaPresetButtonProps> = (
    props: EditManzanitaPresetButtonProps
) => {
    const { itemId } = props;
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <EditListButton onClick={openAside} />
            <Aside isOpen={isAsideOpen} type="form" headerText={"Edit preset"} onDismiss={closeAside}>
                <EditManzanitaPresetForm presetId={itemId} onCancel={closeAside} onSubmit={handleFormSubmit} />
            </Aside>
        </>
    );
};
